module.exports = __webpack_public_path__ + "img/window-lock.a5970bec.svg";